import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(() => ({
  button: {
    "&:hover": {
      background: "#333"
    },
    "&:active": {
      background: "#444"
    }
  }
}));
